import module from '../module';

export default module.directive('supportDirective', [
  function () {
    return {
      restrict: 'E',
      templateUrl: 'app/views/support/index.html',
      controller: 'SupportController',
    };
  },
]);
